/**
 *
 * Asynchronously loads the component for HomaPage
 *
 */
import { LoadingIndicator } from '@/components/loadingIndicator';
import React from 'react';
import { lazyLoad } from 'utils/loadable';

export const SwapPage = lazyLoad(
  () => import('./index'),
  (module) => module.SwapPage,
  { fallback: <LoadingIndicator fullPageHeight /> }
);
